import ProductsList from './List';
import { ProductCreate, ProductEdit } from './Form';

export default {
  list: ProductsList,
  create: ProductCreate,
  edit: ProductEdit,
};
